module.exports = __webpack_public_path__ + "img/teenager-blue.729d5cc4.svg";